import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { SearchInputWrapper } from "../../../../../components/common/datatable/filter/SearchInputWrapper";
import Modal from "../../../../../components/common/form/Modal";
import { DataTable } from "../../../../../components/common/datatable/DataTable";
import { DataTableColumn } from "../../../../../components/common/datatable/DataTableTypes";
import { useGetPrimaryCollectorByStateAndCountyQuery, useSearchAppraisalRollsQuery } from "../../../../data/appraisalRoll/appraisalRollsApi";
import ButtonTray from "../../../../../components/common/form/ButtonTray";
import { handleRTKQuery } from "../../../../../helpers/utils/RtkQueryUtils";
import CommonSelectDropDownTag from "../../../../../components/common/datatable/filter/CommonSelectDropDownTag";
import {
    createOptionListForSelectTag,
    prePopulateFilterTagFromUrl,
    returnAddNewPropertyOption, showToast
} from "../../../../../helpers/utils/Utils";

import { useGetPropertyPickerResultMutation } from "../../../productsApi";
import { addNewDefaultSelectorValue } from "../../../../../helpers/constants";
import { useGetNationalPropertyPickerResultMutation } from "../../../nationalOrdersApi";
import CollectorSearchInputWrapper from "../../../../../components/common/datatable/filter/CollectorSearchInputWrapper";
import SelectField from "../../../../../components/common/form/SelectField";

type Property = {
    id: string;
    taxIdentifier?: string;
    addressLine1?: string;
    legalDescription?: string;
    sellerName?: string;
    state?: string;
    countyName?: string;
    collectorId?: string;
};

type CollectorData = {
    id: string;
    name: string;
};

type Props = {
    show: boolean;
    setShow: (val: boolean) => void;
    orderData: any;
    taxAccountNumber: string;
    setTaxAccountNumber?: (val: string) => void;
    address: string;
    propertyIds: string[];
    setAddress?: (val: string) => void;
    legalDescription: string;
    setLegalDescription?: (val: string) => void;
    ownerName: string;
    setOwnerName?: (val: string) => void;
    isAddAccountPropertyRef: boolean;
    setIsAddAccountPropertyRef: (val: boolean) => void;
    setAddAccountSelectedProperty: (val: Property | null) => void;
    setAddedNewAccount: (val: boolean) => void;
    isHoaEditor?: boolean;
    productSchema?: string;
    getPropertyPickerResultApi?: any;
    getPropertyPickerResult?: any;

};

const EditorPropertyPickerModal: React.FC<Props> = ({
    show,
    setShow,
    orderData,
    taxAccountNumber,
    setTaxAccountNumber = () => {
    },
    address,
    propertyIds,
    setAddress = () => {
    },
    legalDescription,
    setLegalDescription = () => {
    },
    ownerName,
    setOwnerName = () => {
    },
    isAddAccountPropertyRef,
    setIsAddAccountPropertyRef,
    setAddAccountSelectedProperty,
    setAddedNewAccount,
    isHoaEditor = false,
    getPropertyPickerResultApi,
    getPropertyPickerResult,

}) => {

    const [preDefaultCheck, setPreDefaultCheck] = useState(false);
    const [property, setProperty] = useState<any>("");
    const [selectedPropertyList, setSelectedPropertyList] = useState<any[]>([]);
    const [date, setDate] = useState("");

    const [disable, setDisable] = useState(false);
    const [preDefaultFilterHalt, setPreDefaultFilterHalt] = useState(false);

    const primaryCollectorData = useGetPrimaryCollectorByStateAndCountyQuery({
        stateAbbr: orderData.data?.state, countyName: orderData.data?.county
    });
    const [showCollector, setShowCollector] = useState(false);
    const [collectorValue, setCollectorValue] = useState(null);
    const [collectorTagValue, setCollectorTagValue] = useState(null);
    const [collectorId, setCollectorId] = useState<any>(null);
    const [resetDefault, setResetDefault] = useState(false);
    const [suitAddress1, setSuitAddress1] = useState<any>();

    let filterModalOptions = [
        {
            filterModalKey: "id",
            filterModalKeyAccessor: "collectorId",
            showModal: showCollector,
            setShowModal: setShowCollector,
            showModalValue: collectorValue,
            setShowModalValue: setCollectorValue,
            showModalTagValue: collectorTagValue,
            setShowModalTagValue: setCollectorTagValue
        }];

    useEffect(() => {
        filterModalOptions && prePopulateFilterTagFromUrl(filterModalOptions);
        setProperty(addNewDefaultSelectorValue.id);
    }, []);





    useEffect(() => {
        setPreDefaultFilterHalt(true)

        if (primaryCollectorData?.data) {
            setCollectorValue(property !== null && property !== "" ? primaryCollectorData?.data?.name : "");
            setCollectorTagValue(property !== null && property !== "" ? primaryCollectorData?.data?.name : "");
            setCollectorId(primaryCollectorData?.data?.id)
        }
        if (primaryCollectorData?.data == "") {
            setPreDefaultCheck(true);
        }

    }, [primaryCollectorData]);

    const propertyList = orderData?.data?.properties;



    function dismissModal(e: any) {
        e.preventDefault();
        setIsAddAccountPropertyRef(false);
        setShow(false);
    }

    const handleSubmit = (e: any) => {
        e.preventDefault()
        if (isAddAccountPropertyRef && property !== null && property !== "" && property !== undefined) {
            setAddedNewAccount(true);
            dismissModal(e);
        } else {
            if (selectedPropertyList.length > 0) {
                setDisable(true);
                let list = selectedPropertyList.map((property) => {
                    return {
                        ...property,
                        collectorId: property.collectorId
                    }
                });
                setIsAddAccountPropertyRef(false);

                const isValidProperty = property !== undefined && property !== null && property !== "" && property !== "defaultId" ? property : null;

                handleRTKQuery(
                    async () => {
                        const res = await getPropertyPickerResultApi({ list, orderPropertyId: isValidProperty }).unwrap();
                        setDisable(false);
                        setShow(false);

                        if (res.length > 0) {
                            showToast("Account list updated successfully!", "success");
                        } else {
                            showToast("No matching result found!", "info");
                        }

                        return res;
                    },
                    () => setShow(false)
                );


            }
        }
    }
    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | {
        name: string;
        value: any
    } | ChangeEvent<HTMLTextAreaElement>) => {
        const { name, value } = "target" in e ? e.target : e;
        setProperty(value)
    }



    useEffect(() => {
        if (!suitAddress1?.value && orderData?.data) {
            setSuitAddress1({
                id: "defaultId",
                label: "Add New",
                value: "defaultId"
            });
        }
    }, [orderData?.data]);

    useEffect(() => {
        if (resetDefault) {
            setCollectorValue(null);
            setTaxAccountNumber("");
            setAddress("");
            setLegalDescription("");
            setOwnerName("");
        }
        setResetDefault(false)
    }, [resetDefault]);

    useEffect(() => {
        if (!orderData?.data?.properties) return;


        isAddAccountPropertyRef &&
            orderData.data &&
            setAddAccountSelectedProperty(
                suitAddress1?.value !== undefined &&
                    suitAddress1?.value !== "defaultId" &&
                    suitAddress1?.value !== null
                    ? orderData?.data?.properties
                        .filter((cur: any) => cur.id !== 'defaultId')
                        .find((cur: any) => cur.id === suitAddress1?.value)
                    : null
            );

        const filteredProperties = orderData.data.properties.filter((cur: any) => cur.id !== "defaultId");
        const matchedProperty = filteredProperties.find((cur: any) => cur?.id === suitAddress1?.value);




        if (!isAddAccountPropertyRef) {
            if (suitAddress1?.value === 'defaultId') {
                if (orderData.data?.state !== null && orderData.data?.county !== null) {
                    // dispatch(appraisalRollActions.getPrimaryCollectorByStateAndCountyAction(orderData.items?.state, orderData.items?.county))
                }
                setTaxAccountNumber("");
                setAddress("");
                setLegalDescription("");
                setOwnerName("");
                filterModalOptions[0].setShowModalValue(null);
                filterModalOptions[0].setShowModalTagValue(null);
            }

            if (suitAddress1?.value !== "defaultId" && suitAddress1?.value !== null && suitAddress1?.value !== "") {

                let index = orderData.data?.properties?.filter((cur: any) => cur.id !== 'defaultId').findIndex((el: any) => el.id === suitAddress1?.value);

                if (index > -1) {

                    setTaxAccountNumber(orderData.data?.properties?.filter((cur: any) => cur.id !== 'defaultId')[index].taxIdentifier);
                    setAddress(orderData.data?.properties?.filter((cur: any) => cur.id !== 'defaultId')[index].addressLine1);
                    setLegalDescription(orderData?.data?.properties.filter((cur: any) => cur.id !== 'defaultId')[index].legalDescription);
                    setOwnerName(orderData.data?.properties.filter((cur: any) => cur.id !== 'defaultId')[index].sellerName);
                    setCollectorId(primaryCollectorData?.data?.id)
                } else {

                    setTaxAccountNumber("");
                    setAddress("");
                    setLegalDescription("");
                    setOwnerName("");
                    filterModalOptions[0].setShowModalValue(null);
                    filterModalOptions[0].setShowModalTagValue(null);
                    setPreDefaultCheck(true);
                }
                if (suitAddress1?.value !== "" && suitAddress1?.value !== null && suitAddress1?.value !== undefined && suitAddress1?.value !== "defaultId") {
                    setPreDefaultCheck(true);
                    // dispatch(appraisalRollActions.getPrimaryCollectorByStateAndCountyAction(orderData.items?.properties.filter(cur => cur.id !== 'defaultId').find(cur => cur.id === property)?.state, orderData.items?.properties.filter(cur => cur.id !== 'defaultId').find(cur => cur.id === property)?.countyName))
                }
            }

        }
    }, [suitAddress1]);


    const columns: DataTableColumn[] = [

        {
            label: "",
            accessor: "id", canSort: false,
            cell: (props: any) => {
                return <>
                    <input
                        type="checkbox"
                        onChange={() => {
                            setSelectedPropertyList((prevList) => {
                                const isAlreadySelected = prevList.some(
                                    (item) => item.id === props.row.original.id
                                );

                                // Case 1: It's already selected → remove it
                                if (isAlreadySelected) {
                                    return prevList.filter((item) => item.id !== props.row.original.id);
                                }

                                // Case 2: Add new item
                                if (property !== "defaultId") {
                                    return [props.row.original]; // Replace list with current item
                                } else {
                                    return [...prevList, props.row.original]; // Add to existing list
                                }
                            });
                        }}
                        onClick={() => setDate(props.row.original.id + Date.now())}
                        checked={selectedPropertyList.some((e) => e.id === props.row.original.id)}
                        disabled={
                            !selectedPropertyList.some((e) => e.id === props.row.original.id) &&
                            selectedPropertyList.some(
                                (el) =>
                                    el.taxAccountNumber === props.row.original.taxAccountNumber &&
                                    el.geographicId === props.row.original.geographicId &&
                                    el.taxYear !== props.row.original.taxYear &&
                                    el.collectorId === props.row.original.collectorId
                            )
                        }
                    />

                </>

            }
        },

        {
            label: "Tax Year", accessor: "taxYear",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"number"} placeholder={"Tax Year..."} name={"taxYear"}
                    accessor={"taxYear"} />,
                overrideFilterLabel: "Tax Year",
                overrideFilterAccessor: "taxYear"
            }]
        },


        {
            label: "Tax ID", accessor: "taxAccountNumber",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Tax Account No..."}
                    name={"taxAccountNumber"} accessor={"taxAccountNumber"}
                    defaultValue={taxAccountNumber == null || taxAccountNumber == "" ? "" : taxAccountNumber} />,
                overrideFilterLabel: "Tax ID",
                overrideFilterAccessor: "taxAccountNumber"
            }]
        },

        {
            label: "Geo ID", accessor: "geographicId",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Geo Id..."}
                    name={"geographicId"} accessor={"geographicId"} />,
                overrideFilterLabel: "Geo Id",
                overrideFilterAccessor: "geographicId"
            }]
        },

        {
            label: "Collector",
            accessor: "collectorName",
            overrideSortColumn: "collectorId",
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper value={collectorValue || ''} accessor="collectorId" />,
                overrideFilterAccessor: "collectorId",
                overrideFilterLabel: "Collector",
            }]
        },
        {
            label: "Address", accessor: "situsAddress",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Address..."}
                    name={"situsAddress"} accessor={"situsAddress"}
                    defaultValue={address == null || address == "" ? "" : address} />,
                overrideFilterLabel: "Situs Address",
                overrideFilterAccessor: "situsAddress"
            }]
        },

        {
            label: "Subdivision", accessor: "subdivisionName",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Subdivision Name..."}
                    name={"subdivision"} accessor={"subdivisionName"} />,
                overrideFilterLabel: "Subdivision Name",
                overrideFilterAccessor: "subdivisionName"
            }]
        },

        {
            label: "Sub Code", accessor: "subdivisionCode",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Sub Code..."}
                    name={"subdivisionCode"} accessor={"subdivisionCode"} />,

                overrideFilterAccessor: "subdivisionCode"
            }]
        },

        {
            label: "Owner", accessor: "ownerName",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Owner Name..."}
                    name={"ownerName"} accessor={"ownerName"}
                    defaultValue={ownerName == null || ownerName == "" ? "" : ownerName} />,
                overrideFilterLabel: "Owner Name",
                overrideFilterAccessor: "ownerName"
            }]
        },

        {
            label: "Legal", accessor: "legalDescription",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Legal Description..."}
                    name={"legalDescription"} accessor={"legalDescription"}
                    defaultValue={legalDescription == null || legalDescription == "" ? "" : legalDescription} />,
                overrideFilterLabel: "Legal Description",
                overrideFilterAccessor: "legalDescription"
            }]
        },

    ]



    return (

        <Modal
            title={isAddAccountPropertyRef ? "Add New Account" : "Property Picker"}
            show={show}
            setShow={setShow}
            hoa={isHoaEditor}
            className="w-3/4 bg-text-0 rounded-lg shadow-lg"
            fields={
                <div className="bg-text-0 modal-body">


                    <SelectField
                        placeholder='No Property Selected...'
                        value={suitAddress1} // make sure this object exactly matches one in options
                        options={
                            orderData?.data && Array.isArray(orderData?.data?.properties)
                                ? [
                                    { value: "defaultId", label: "Add New" },
                                    ...orderData.data.properties
                                        .filter((cur: any) => !propertyIds.includes(cur.propertyResult.taxId))
                                        .map((item: any) => ({
                                            value: item.id,
                                            label: `${item.sequence || ""}. ${item.addressLine1 || "No Address"}`
                                        }))
                                ]
                                : [{ value: "defaultId", label: "Add New" }]
                        }
                        onChange={(selectedOption: any) => {
                            if (!selectedOption)
                                setResetDefault(true);

                            setSuitAddress1(selectedOption);
                        }}
                        required
                        hideLabel={true}
                    />


                    {!isAddAccountPropertyRef && collectorId && (
                        <>
                            <DataTable
                                isHoa={isHoaEditor}
                                columns={columns}
                                actions={{
                                    fetchAction: useSearchAppraisalRollsQuery,
                                }}

                                defaultFilter={{
                                    pageNumber: 0,
                                    pageSize: 5,
                                    sort: "taxYear",
                                    sortOrder: "DESCENDING",
                                    collectorId: collectorId,
                                    taxAccountNumber: taxAccountNumber,
                                    situsAddress: address,
                                    legalDescription: legalDescription,

                                }}
                                defaultFilterFormExpanded={true}
                                defaultSortOptions={{
                                    accessor: "taxYear",
                                    direction: "desc",
                                }}
                                renderOptions={{
                                    skipUserSettingRender: true,
                                    skipFilterButtonRender: true,
                                }}
                                appendFilterToUrl={false}
                                setResetDefaultFilter={setResetDefault}
                                resetDefaultFilter={resetDefault}
                                searchOnApply={true}
                            />

                            {selectedPropertyList.length > 0 && (
                                <div className="mt-3">
                                    <h1 className="mb-2 text-2xl font-semibold">Selected Property</h1>
                                    <table className="table table-hover table-striped">
                                        <thead className="bg-highlight-5 text-text-0 relative text-left">
                                            <tr>
                                                <th>Tax Year</th>
                                                <th>Tax ID</th>
                                                <th>Geo ID</th>
                                                <th>Collector</th>
                                                <th>Address</th>
                                                <th>Subdivision</th>
                                                <th>Owner</th>
                                                <th>Legal</th>
                                            </tr>
                                        </thead>
                                        <tbody
                                            className={`text-left ${selectedPropertyList.length > 4 ? "table_height" : ""
                                                }`}
                                        >
                                            {selectedPropertyList.map((current: any) => (
                                                <tr key={`${current.id}-${current.taxYear}`}>
                                                    <td>{current.taxYear}</td>
                                                    <td>{current.taxAccountNumber}</td>
                                                    <td>{current.geographicId}</td>
                                                    <td>{current.collectorName ?? "-"}</td>
                                                    <td>{current.situsAddress}</td>
                                                    <td>{current.subdivisionName}</td>
                                                    <td>{current.ownerName}</td>
                                                    <td>{current.legalDescription}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </>
                    )}

                    <ButtonTray
                        buttons={[
                            {
                                buttonProps: {
                                    btnText: "Cancel",
                                    onClick: () => setShow(false),
                                    type: "cancel",
                                    isDisabled: disable,
                                },
                                buttonType: "button",
                            },
                            {
                                buttonProps: {
                                    btnText: "Add",
                                    onClick: handleSubmit,
                                    type: "submit",
                                    isDisabled: disable,
                                    isLoading: getPropertyPickerResult?.isLoading,
                                    isHoa: isHoaEditor
                                },
                                buttonType: "button",
                            },
                        ]}
                        align="start"
                        gap={2}
                    />
                </div>
            }
        />

    );
}

export default EditorPropertyPickerModal;

